<style lang="less" scoped>
.messagec{width: 621px;height: 600px;background-color: #fff;}
.title{margin-top: 20px;text-align: left;margin-left: 35px;font-size: 19px;font-weight: bold;color: #0152b5;
  .i{color: #0152b5;font-weight: 1000;}
  .el-icon-close{float: right;margin-right: 30px;}
}
.tabs{margin-top: 30px;
.setting{
  .titledata{width: 83%;margin: 5px auto;text-align: left;font-weight: bold;}
  .afteru{color: red;}
//  span{font-size: 15px; font-weight:bold;}
 .el-input{width: 83%;margin: 10px auto;}
}
}
</style>
<template>
  <div class="messagec">
    <div class="title">
      <i class="el-icon-chat-dot-square"></i>反馈与建议
      <i class="el-icon-close" @click="onclose"></i>
    </div>
    <div class="tabs">
      <div class="setting">
        <div class="titledata">
          标题<span class="afteru">*</span>
        </div>
        <div>
          <el-input v-model="title" placeholder="请输入反馈（建议）的板块名称"></el-input>
        </div>
      </div>
      <div class="setting">
        <div class="titledata">
          您的反馈或建议<span class="afteru">*</span>
        </div>
        <div>
          <el-input
            style="width: 83%;margin: 10px auto;"
            type="textarea"
            :rows="4"
            placeholder="请输入反馈（建议）内容"
            v-model="content">
          </el-input>
        </div>
      </div>
      <div class="setting">
        <div class="titledata">
          上传附件
        </div>
        <div style="width: 83%;margin: 10px auto;text-align:left;">
          <!-- <el-input v-model="input" placeholder="请输入反馈（建议）的板块名称"></el-input> -->
          <!-- <el-button style="margin-right:10px;" type="primary" plain @click="upload">上传附件</el-button><span style="font-size:15px;">允许上传JPG、png等类型的文件</span> -->
          <el-upload
            class="upload-demo"
            :action="url"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemovePicture"
            :limit="1"
            :on-exceed="exceed"
            :on-success="onSuccess"
            :on-change="handleEditChange"
            @mouseover.native="getPhoUrl"
            :file-list="fileList">
            <el-button size="small" type="primary">上传附件</el-button>
            <div slot="tip" class="el-upload__tip">允许上传JPG、png等类型的文件</div>
          </el-upload>
        </div>
      </div>
      <div class="setting">
        <div class="titledata">
          您的联络方式<span class="afteru">*</span>
        </div>
        <div>
          <el-input v-model="contact" placeholder="请输入电话、邮箱均可"></el-input>
        </div>
      </div>
      <div style="width: 83%;margin: 10px auto;text-align:left;">
         <el-button type="primary" @click="determine">提交建议</el-button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data()
  {
    return {
      url: '',
      title: '',
      content: '',
      contact: '',
      dialogVisible: false,
      form: {
        thumb: ''
      },
      fileList: []
    }
  },
  methods: {
    determine()
    {
      let uname = localStorage.getItem('username')
      let obj = {
        cmd: 'add',
        _major: 11,
        _minor: 123,
        retAtt: 1,
        title: this.title,
        content: this.content,
        contact: this.contact,
        thumb: this.form.thumb,
        date: (Date.parse(new Date()) / 1000),
        username: uname
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret)
        {
          this.$message({message: '提交成功', type: 'success', customClass: 'mzindex'})
          this.title = ''
          this.content = ''
          this.contact = ''
          this.form.thumb = ''
          this.$parent.feedBack()
        }
      })
    },
    upload()
    {
      this.dialogVisible = true
    },
    //上传图片
    getPhoUrl()
    {
      let that = this
      window.public.onUploadPicture(that)
    },
    //图片上传之前的钩子
    beforeUploadPicture(file)
    {
      let that = this
      window.public.beforeUploadPicture(file, that)
    },
    //上传中
    handlePictureCardPreview(file)
    {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    //图片上传成功
    onSuccess(response)
    {
      let that = this
      window.public.onSuccess(response, that)
    },
    //上传发生变化（上传或者删除）
    handleEditChange(file, fileList)
    {
      let that = this
      window.public.handleEditChange(file, fileList, that)
    },
    //删除图片
    handleRemovePicture(fileList)
    {
      let that = this
      window.public.handleRemovePicture(fileList, that)
    },
    //超出上传次数
    exceed()
    {
      this.$message({message: '您已上传过了，若需要换一个，请先删除上一个', type: 'error', customClass: 'mzindex'})
    },
    onclose()
    {
      this.$parent.feedBack()
      this.title = ''
      this.content = ''
      this.contact = ''
      this.form.thumb = ''
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/assembly/FeedBack.vue